<template>
  <div
    v-if="mostrarModalFicha"
    @click.self="cerrarModalFicha"
    class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-gray-900 bg-opacity-50"
  >
    <div
      class="relative bg-white rounded-lg shadow dark:bg-gray-700 mx-4 sm:mx-auto w-full max-w-lg md:max-w-2xl p-6 overflow-auto max-h-screen"
    >
      <!-- Botones de navegación -->
      <div class="flex space-x-4 border-b pb-2 mb-4">
        <button
          :class="
            pestanaActiva === 'tratamiento'
              ? 'font-bold border-b-2 border-blue-600'
              : 'text-gray-500'
          "
          @click="activarPestanaTratamiento"
        >
          Tratamiento
        </button>
        <button
          :class="
            pestanaActiva === 'recomendaciones'
              ? 'font-bold border-b-2 border-blue-600'
              : 'text-gray-500'
          "
          @click="activarPestanaRecomendaciones"
        >
          Recomendaciones
        </button>

        <!--  Nueva pestaña "Documentos" -->
        <button
          :class="
            pestanaActiva === 'documentos'
              ? 'font-bold border-b-2 border-blue-600'
              : 'text-gray-500'
          "
          @click="pestanaActiva = 'documentos'"
        >
          Documentos
        </button>

        <button
          :class="
            pestanaActiva === 'analisisPiel'
              ? 'font-bold border-b-2 border-blue-600'
              : 'text-gray-500'
          "
          @click="pestanaActiva = 'analisisPiel'"
        >
          Análisis de Piel
        </button>
      </div>

      <!-- Tratamiento -->
      <div v-if="pestanaActiva === 'tratamiento'" class="grid gap-4">
        <div v-if="tratamientos.length === 0" class="text-gray-500">
          No hay registros de tratamiento.
        </div>

        <div
          v-else
          v-for="tratamiento in tratamientos"
          :key="tratamiento.id"
          class="bg-white shadow p-4 rounded border space-y-2"
        >
          <p><strong>Fecha:</strong> {{ tratamiento.fecha }}</p>
          <p><strong>Hora:</strong> {{ tratamiento.hora }}</p>
          <p
            v-if="tratamiento.tratamiento?.consentimientoLaser?.aceptado"
            class="text-green-600 text-sm"
          >
            Consentimiento aceptado por
            {{ tratamiento.tratamiento.consentimientoLaser.aceptadoPor }} el
            {{ tratamiento.tratamiento.consentimientoLaser.fecha }} a las
            {{ tratamiento.tratamiento.consentimientoLaser.hora }}
          </p>

          <p><strong>Servicios:</strong></p>
          <ul
            v-if="tratamiento.servicios && tratamiento.servicios.length"
            class="list-disc ml-6"
          >
            <li v-for="(servicio, index) in tratamiento.servicios" :key="index">
              {{ servicio.nombre }}
            </li>
          </ul>
          <p v-else class="text-gray-400 italic">Sin servicios asignados.</p>

          <!--  Agregar nueva nota con foto -->
          <div class="flex items-start space-x-2">
            <textarea
              v-model="nuevaNota[tratamiento.id]"
              placeholder="Escribe una nota..."
              class="w-full p-2 border rounded"
            ></textarea>

            <input
              type="file"
              @change="onFileChange($event, tratamiento.id)"
              class="border p-2 rounded text-sm"
            />

            <button
              @click="guardarNota(tratamiento.id)"
              class="bg-blue-600 text-white px-3 py-1 rounded"
            >
              Guardar
            </button>
          </div>

          <!--  Lista de notas previas -->
          <div v-if="tratamiento.notas && tratamiento.notas.length">
            <h4 class="text-sm font-semibold">Notas previas:</h4>
            <ul class="list-disc ml-6">
              <li v-for="(nota, index) in tratamiento.notas" :key="index">
                <span class="text-gray-600 text-xs"
                  >{{ nota.fecha }} {{ nota.hora }}</span
                ><br />
                {{ nota.texto }}
                <img
                  v-if="nota.imagenUrl"
                  :src="nota.imagenUrl"
                  class="w-32 h-32 object-cover mt-2"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- Panel de contenido -->
      <div v-if="pestanaActiva === 'analisisPiel'" class="space-y-4">
        <!--  Mostrar historial de análisis guardados -->
        <div v-if="analisisGuardado && analisis.length">
          <h3 class="font-semibold text-lg">Evaluaciones guardadas</h3>
          <div
            v-for="(item, i) in analisis"
            :key="i"
            class="border border-gray-300 rounded p-3 mb-3 bg-gray-50"
          >
            <p><strong>Fecha:</strong> {{ item.fecha }}</p>
            <p><strong>Tipo de piel:</strong> {{ item.tipoPiel }}</p>
            <p><strong>Observaciones:</strong> {{ item.observaciones }}</p>
            <p><strong>Alteraciones:</strong></p>
            <ul class="list-disc ml-6">
              <li v-for="(alt, idx) in item.alteraciones" :key="idx">
                {{ alt }}
              </li>
            </ul>
          </div>
        </div>

        <!--  Formulario para nuevo análisis -->
        <div>
          <label class="block text-sm font-medium">Tipo de Piel:</label>
          <select
            v-model="nuevoAnalisis.tipoPiel"
            class="border p-2 rounded w-full"
          >
            <option disabled value="">Seleccione...</option>
            <option>Piel Mixta</option>
            <option>Piel Grasa</option>
            <option>Piel Seca</option>
            <option>Sensible</option>
          </select>

          <label class="block text-sm font-medium mt-4">Observaciones:</label>
          <textarea
            v-model="nuevoAnalisis.observaciones"
            class="border p-2 rounded w-full"
            rows="3"
          ></textarea>

          <label class="block text-sm font-medium mt-4"
            >Alteraciones de la piel:</label
          >
          <div class="grid grid-cols-2 gap-2">
            <div v-for="item in alteracionesDisponibles" :key="item">
              <label class="flex items-center space-x-2">
                <input
                  type="checkbox"
                  :value="item"
                  v-model="nuevoAnalisis.alteraciones"
                />
                <span>{{ item }}</span>
              </label>
            </div>
          </div>

          <button
            @click="guardarAnalisisPiel"
            class="mt-4 bg-green-600 text-white px-4 py-2 rounded"
          >
            Guardar Evaluación
          </button>
        </div>
      </div>

      <!-- Solicitudes -->
      <div v-if="pestanaActiva === 'solicitudes'" class="mt-4">
        <RevisarSolicitudesDosis :paciente="pacienteSeleccionado" />
      </div>

      <div v-if="pestanaActiva === 'documentos'" class="mt-4">
        <DocumentosPacienteAdmin :paciente="pacienteSeleccionado" />
      </div>
      <!-- Recomendaciones -->
      <div v-if="pestanaActiva === 'recomendaciones'" class="grid gap-4">
        <h3 class="text-lg font-semibold mb-2">Productos recomendados</h3>

        <div v-if="productosDisponibles.length === 0" class="text-gray-500">
          No hay productos cargados.
        </div>

        <div v-else class="space-y-2">
          <label
            v-for="producto in productosDisponibles"
            :key="producto.id"
            class="flex items-center space-x-2 p-2 rounded hover:bg-gray-50"
          >
            <input
              type="checkbox"
              :value="producto"
              v-model="recomendacionesSeleccionadas"
            />
            <div class="flex-1">
              <span
                >{{ producto.nombre }} - ${{ producto.precio.toFixed(2) }}</span
              >
              <span
                v-if="
                  recomendacionesSeleccionadas.some((r) => r.id === producto.id)
                "
                class="ml-2 text-xs text-green-600 bg-green-100 px-2 py-1 rounded"
              >
                ✓ Recomendado
              </span>
            </div>
          </label>
        </div>

        <button
          @click="guardarRecomendaciones"
          class="mt-3 bg-green-600 text-white px-4 py-2 rounded"
        >
          Guardar Recomendaciones
        </button>
      </div>
    </div>
  </div>
  <section class="bg-white dark:bg-gray-900">
    <div class="flex flex-col px-4 sm:px-6 lg:px-8">
      <h2
        class="mb-4 text-xl font-bold text-gray-900 dark:text-white text-center"
      >
        Manejo de Clientes
      </h2>
      <div
        class="flex flex-col sm:flex-row sm:justify-between gap-4 items-center"
      >
        <button
          @click="abrirModal"
          class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
        >
          Crear Cliente
        </button>
      </div>

      <div
        v-if="mostrarModal"
        @click.self="cerrarModal"
        class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-gray-900 bg-opacity-50"
      >
        <div
          class="relative bg-white rounded-lg shadow dark:bg-gray-700 mx-4 sm:mx-auto w-full max-w-lg md:max-w-2xl p-6 overflow-auto max-h-screen"
        >
          <form
            @submit.prevent="esEdicion ? actualizarPaciente() : crearPaciente()"
            class="space-y-6"
          >
            <div class="grid gap-4">
              <!-- Campos dinámicos de la ficha -->
              <div
                v-for="question in questions"
                :key="question.id"
                class="col-span-full"
              >
                <label
                  :for="question.id"
                  class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >{{ question.label }}</label
                >

                <!-- Multi input -->
                <div
                  v-if="question.type === 'multi-input' && question.inputs"
                  class="grid gap-3 sm:grid-cols-2"
                >
                  <div
                    v-for="input in question.inputs"
                    :key="input.id"
                    class="flex flex-col"
                  >
                    <label
                      :for="input.id"
                      class="text-xs text-gray-600 dark:text-gray-300"
                      >{{ input.label }}</label
                    >
                    <input
                      :id="input.id"
                      v-model="answers[input.id]"
                      :type="input.type || 'text'"
                      :placeholder="input.placeholder || ''"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    />
                  </div>
                </div>

                <!-- Textarea -->
                <textarea
                  v-else-if="question.type === 'textarea'"
                  :id="question.id"
                  v-model="answers[question.id]"
                  :rows="question.rows || 3"
                  :placeholder="question.placeholder || ''"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                ></textarea>

                <!-- Checkbox group -->
                <div
                  v-else-if="question.type === 'checkbox-group'"
                  class="space-y-2"
                >
                  <label
                    v-for="option in question.options"
                    :key="option.value"
                    class="flex items-center space-x-2"
                  >
                    <input
                      type="checkbox"
                      :value="option.value"
                      v-model="answers[question.id]"
                    />
                    <span>{{ option.label }}</span>
                  </label>
                </div>

                <!-- Radio -->
                <div v-else-if="question.type === 'radio'" class="flex gap-4">
                  <div
                    v-for="opt in question.options"
                    :key="opt.value"
                    class="flex items-center"
                  >
                    <input
                      type="radio"
                      :id="`${question.id}-${opt.value}`"
                      :name="question.id"
                      :value="opt.value"
                      v-model="answers[question.id]"
                      class="mr-2"
                    />
                    <label :for="`${question.id}-${opt.value}`">{{
                      opt.label
                    }}</label>
                  </div>
                </div>

                <!-- Default input -->
                <input
                  v-else
                  :type="
                    question.inputType ||
                    (question.type === 'date'
                      ? 'date'
                      : question.type === 'email'
                      ? 'email'
                      : 'text')
                  "
                  :id="question.id"
                  v-model="answers[question.id]"
                  :placeholder="question.placeholder || ''"
                  :readonly="question.readOnly || false"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>
            </div>

            <!-- Botones -->
            <div class="flex justify-end space-x-4">
              <button
                type="submit"
                class="px-5 py-2.5 text-sm font-medium text-white bg-blue-700 rounded-lg focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-900 hover:bg-blue-800"
              >
                {{ esEdicion ? "Actualizar Paciente" : "Crear Paciente" }}
              </button>

              <button
                @click="cerrarModal"
                type="button"
                class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-700 dark:bg-gray-600 dark:text-white"
              >
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="mt-8 grid gap-4 md:grid-cols-[2fr,1fr] items-end">
        <div>
          <label
            for="buscar"
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >Buscar por nombre, apellido, correo o teléfono</label
          >
          <input
            v-model="filtro"
            @input="filtrarPacientes"
            type="text"
            id="buscar"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            placeholder="Escribe para filtrar..."
          />
        </div>
        <div>
          <label
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Pacientes por página
          </label>
          <select
            v-model.number="pacientesPorPagina"
            @change="actualizarPacientesPorPagina"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          >
            <option
              v-for="opcion in opcionesPorPagina"
              :key="`opcion-${opcion}`"
              :value="opcion"
            >
              {{ opcion }} por vista
            </option>
          </select>
        </div>
      </div>

      <div class="mt-8">
        <h2
          class="text-xl font-bold text-gray-900 dark:text-white mb-4 text-center"
        >
          Lista Clientes
        </h2>
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table
            class="w-full text-sm text-left text-gray-500 dark:text-gray-400"
          >
            <thead
              class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0"
            >
              <tr>
                <th scope="col" class="px-6 py-3">Nombre</th>
                <th scope="col" class="px-6 py-3">Apellido</th>
                <th scope="col" class="px-6 py-3">Dirección</th>
                <th scope="col" class="px-6 py-3">Teléfono</th>
                <th scope="col" class="px-6 py-3">Email</th>
                <th scope="col" class="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <!-- Aquí se renderizan solo los pacientes de la página actual -->
              <tr v-for="paciente in pacientesPaginados" :key="paciente.id">
                <td
                  class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {{ paciente.nombre }}
                </td>
                <td
                  class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {{ paciente.apellido }}
                </td>
                <td class="px-6 py-4">{{ paciente.direccion }}</td>
                <td class="px-6 py-4">{{ paciente.telefono }}</td>
                <td class="px-6 py-4">{{ paciente.email }}</td>

                <td class="px-6 py-4">
                  <div
                    class="flex flex-wrap justify-end gap-2 text-xs font-medium"
                  >
                    <button
                      @click="editarPaciente(paciente)"
                      class="text-white bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:outline-none focus:ring-blue-300 rounded-md px-3 py-1.5"
                    >
                      Perfil
                    </button>
                    <button
                      @click="abrirModalFicha(paciente)"
                      class="text-blue-600 border border-blue-200 hover:bg-blue-50 focus:ring-2 focus:outline-none focus:ring-blue-300 rounded-md px-3 py-1.5"
                    >
                      Detalles
                    </button>
                    <button
                      @click="eliminarPaciente(paciente)"
                      class="text-white bg-red-600 hover:bg-red-700 focus:ring-2 focus:outline-none focus:ring-red-300 rounded-md px-3 py-1.5"
                    >
                      Eliminar
                    </button>
                  </div>

                  <!-- AÑADIDO: Mostrar botones por cada cita del día que requiera consentimiento -->
                  <div
                    v-for="cita in citasDelDia(paciente.uid)"
                    :key="cita.id"
                    class="text-right mt-2"
                  >
                    <template v-if="requiereConsentimiento(cita)">
                      <div class="text-xs text-gray-600 italic">
                        {{ cita.hora }} -
                        {{ cita.servicios.map((s) => s.nombre).join(", ") }}
                      </div>

                      <button
                        @click="abrirConsentimiento(cita)"
                        class="text-red-600 font-bold text-xs underline hover:text-red-800"
                      >
                        ¡Consentimiento requerido!
                      </button>
                    </template>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Modal de consentimiento -->
        <div
          v-if="mostrarModalConsentimiento"
          class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
        >
          <div
            class="bg-white p-6 rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto"
          >
            <h2 class="text-lg font-bold mb-4">
              Consentimiento de depilación láser
            </h2>

            <textarea
              v-model="consentimientoTexto"
              readonly
              class="w-full h-[60vh] border border-gray-300 p-3 text-sm"
            ></textarea>

            <div class="mt-4 flex justify-end gap-2">
              <button
                @click="mostrarModalConsentimiento = false"
                class="px-4 py-2 text-sm bg-gray-300 rounded"
              >
                Cancelar
              </button>
              <button
                @click="aceptarConsentimiento"
                class="bg-green-600 text-white px-4 py-2 rounded"
              >
                Aceptar y firmar
              </button>
            </div>
          </div>
        </div>

        <!-- Paginación Flowbite -->
        <nav aria-label="Page navigation example" class="mt-4">
          <div class="relative overflow-x-auto">
            <div class="flex flex-col items-center">
              <!-- Texto informativo -->
              <span class="text-sm text-gray-700 dark:text-gray-400">
                <span class="font-semibold text-gray-900 dark:text-white">
                  Mostrando {{ pacientesPaginados.length }} de
                  {{
                    filtro
                      ? pacientesFiltrados.length
                      : pacientesActualizados.length
                  }}
                  pacientes</span
                >
              </span>

              <div class="inline-flex mt-2 xs:mt-0">
                <!-- Botón de Anterior -->
                <button
                  @click="cambiarPagina(paginaActual - 1)"
                  :disabled="paginaActual === 1"
                  class="flex items-center justify-center px-3 h-8 text-sm font-medium text-white bg-blue-700 rounded-l hover:bg-blue-800 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700"
                >
                  <svg
                    class="w-3.5 h-3.5 me-2 rtl:rotate-180"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 10"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13 5H1m0 0 4 4M1 5l4-4"
                    />
                  </svg>
                  Prev
                </button>

                <!-- Botón de Siguiente -->
                <button
                  @click="cambiarPagina(paginaActual + 1)"
                  :disabled="paginaActual === totalPaginas"
                  class="flex items-center justify-center px-3 h-8 text-sm font-medium text-white bg-blue-700 rounded-e hover:bg-blue-800 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700"
                >
                  Next
                  <svg
                    class="w-3.5 h-3.5 ms-2 rtl:rotate-180"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 10"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M1 5h12m0 0L9 1m4 4L9 9"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </section>
</template>

<script>


import {
  collection,
  getDocs,
  getDoc,
  query,
  where,
  updateDoc,
  deleteDoc,
  doc,
  setDoc,
  addDoc,
  writeBatch,
  arrayUnion,
  serverTimestamp
} from "firebase/firestore";
import { db, firebaseConfig } from "../../firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { fetchSignInMethodsForEmail } from "firebase/auth";
import { initializeApp, deleteApp } from "firebase/app";
import {
  getStorage,
  ref as sRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import RevisarSolicitudesDosis from "@/components/views/RevisarSolicitudesDosis.vue";
import DocumentosPacienteAdmin from "@/components/views/DocumentosPacienteAdmin.vue";
import eventBus from "@/utils/eventBus";
import { CONSENTIMIENTO_DEPILACION_LASER } from "@/utils/consentimientos";
import { replacePlaceholders } from "@/utils/placeholderUtils";

import { questions, buildEmptyAnswers } from "@/utils/questions.js";
const storage = getStorage();

export default {
  components: {
    RevisarSolicitudesDosis,
    DocumentosPacienteAdmin,
  },
  data() {
    return {
      mostrarModal: false,
      nombre: "",
      apellido: "",
      direccion: "",
      telefono: "",
      email: "",
      condiciones: "",
      medicamentos: "",
      pacientes: [],
      citasGlobales: [],
      pacientesFiltrados: [],
      filtro: "",
      modoEdicionFicha: false,
      pacienteEditado: {},
      esEdicion: false,
      pacienteEditandoId: null,
      autocomplete: null,
      coordenadas: null,
      direccionValida: true,
      direccionInvalida: null,
      paginaActual: 1,
      pacientesPorPagina: 15,
      opcionesPorPagina: [10, 15, 25, 50],
      mostrarModalFicha: false,
      pacienteSeleccionado: {},
      questions,
      answers: buildEmptyAnswers(),
      pestanaActiva: "tratamiento",
      tratamientos: [],
      selectedImage: null,
      nuevaNota: {},
      productosDisponibles: [],
      recomendacionesSeleccionadas: [],
      analisis: {},
      mostrarModalConsentimiento: false,
      pacienteConsentimiento: null,
      consentimientoTexto: "",
      citaConsentimientoId: null,
      analisisGuardado: false,
      nuevoAnalisis: {
        tipoPiel: "",
        observaciones: "",
        alteraciones: [],
      },
      alteracionesDisponibles: [
        "Ampollas",
        "Cicatriz",
        "Quistes",
        "Úlcera",
        "Nódulos",
        "Desvitalizada",
        "Tumor",
        "Deshidratada",
        "Vesícula",
        "Líneas de Expresión",
        "Ronchas",
        "Arrugas",
        "Costra",
        "Reactiva",
        "Excoriación",
        "Inflamada",
        "Acné Excoriee",
        "Escama",
        "Fisura",
        "Hipopigmentación",
        "Queloide",
        "Hiperpigmentación",
      ],
    };
  },
  computed: {
    pacientesActualizados() {
      console.log(" Ejecutando pacientesActualizados()");

      if (!this.pacientes?.length) {
        console.warn("📭 No hay pacientes cargados");
        return [];
      }

      if (!this.citasGlobales?.length) {
        return this.pacientes;
      }

      const hoy = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"

      return this.pacientes.map((p) => {
        let requiereConsentimiento = false;

        //  Filtramos SOLO citas del día de hoy para este paciente
        const citasPaciente = this.citasGlobales.filter(
          (c) => c.pacienteId === p.uid && c.fecha === hoy
        );

        console.log(` Evaluando paciente: ${p.nombre} (${p.uid})`);
        console.log(` Total citas de hoy: ${citasPaciente.length}`);

        for (const cita of citasPaciente) {
          const servicios = cita.servicios || [];

          for (const servicio of servicios) {
            const categoriaNombre =
              this.categoriasMap?.[servicio?.categoria] || "";
            const consentimiento1 =
              cita?.tratamiento?.consentimientoLaser?.aceptado === true;
            const consentimiento2 = cita?.consentimientoBase?.aceptado === true;
            const consentimiento = consentimiento1 || consentimiento2;

            console.log(" Servicio:", servicio.nombre || "sin nombre");
            console.log(" Categoría:", categoriaNombre);
            console.log("Consentimiento aceptado?", consentimiento);

            if (
              categoriaNombre.toLowerCase().includes("laser") &&
              !consentimiento
            ) {
              console.log(" Requiere consentimiento para esta cita de hoy");
              requiereConsentimiento = true;
              break;
            }
          }

          if (requiereConsentimiento) break;
        }

        return {
          ...p,
          requiereConsentimiento,
        };
      });
    },

    totalPaginas() {
      const pacientesParaMostrar = this.filtro.trim()
        ? this.pacientesFiltrados
        : this.pacientesActualizados;
      const total = pacientesParaMostrar.length || 0;
      const paginas = Math.ceil(total / this.pacientesPorPagina) || 1;
      return Math.max(1, paginas);
    },

    pacientesPaginados() {
      const pacientesParaMostrar = this.filtro.trim()
        ? this.pacientesFiltrados
        : this.pacientesActualizados;
      const inicio = (this.paginaActual - 1) * this.pacientesPorPagina;
      const fin = this.paginaActual * this.pacientesPorPagina;
      return pacientesParaMostrar.slice(inicio, fin);
    },
  },

  methods: {
    calcEdad(fechaISO) {
      if (!fechaISO) return "";
      const fecha = new Date(fechaISO);
      if (Number.isNaN(fecha.getTime())) return "";
      const hoy = new Date();
      let edad = hoy.getFullYear() - fecha.getFullYear();
      const mes = hoy.getMonth() - fecha.getMonth();
      if (mes < 0 || (mes === 0 && hoy.getDate() < fecha.getDate())) {
        edad--;
      }
      return edad >= 0 ? String(edad) : "";
    },

    sincronizarEdadDesdeFecha() {
      this.answers.edad = this.calcEdad(this.answers.fechaNacimiento);
    },

    obtenerEmailNormalizado() {
      const raw =
        (this.answers.email ?? this.email ?? "").toString().trim();
      return {
        raw,
        lower: raw.toLowerCase(),
      };
    },

    extraerNombreApellido(answers = {}) {
      const nombreDirecto = (answers.nombre || this.nombre || "")
        .toString()
        .trim();
      const apellidoDirecto = (answers.apellido || this.apellido || "")
        .toString()
        .trim();

      if (nombreDirecto && apellidoDirecto) {
        return { nombre: nombreDirecto, apellido: apellidoDirecto };
      }

      const fullName = (answers.fullName || "")
        .toString()
        .trim();
      if (fullName) {
        const partes = fullName.split(/\s+/);
        const nombre = nombreDirecto || partes.shift() || "";
        const apellido = apellidoDirecto || partes.join(" ");
        return { nombre: nombre, apellido: apellido || "" };
      }

      return { nombre: nombreDirecto || "", apellido: apellidoDirecto || "" };
    },

    citasDelDia(pacienteId) {
      const hoy = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"
      return this.citasGlobales.filter(
        (c) => c.pacienteId === pacienteId && c.fecha === hoy
      );
    },

    requiereConsentimiento(cita) {
      const servicios = cita.servicios || [];

      return servicios.some((servicio) => {
        const categoriaNombre = this.categoriasMap?.[servicio?.categoria] || "";
        const consentimiento1 =
          cita?.tratamiento?.consentimientoLaser?.aceptado === true;
        const consentimiento2 = cita?.consentimientoBase?.aceptado === true;
        const consentimiento = consentimiento1 || consentimiento2;

        return (
          categoriaNombre.toLowerCase().includes("laser") && !consentimiento
        );
      });
    },

    async cargarCitasGlobales() {
      try {
        const snapshot = await getDocs(collection(db, "citasGlobales"));
        this.citasGlobales = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log("✅ citasGlobales recargadas:", this.citasGlobales.length);
      } catch (err) {
        console.error("❌ Error al cargar citasGlobales:", err);
      }
    },

    async aceptarConsentimiento() {
      try {
        const citaId = this.citaConsentimiento?.id;
        const paciente = this.pacienteConsentimiento;

        if (!citaId || !paciente?.uid) {
          throw new Error("No hay cita activa o paciente definido");
        }

        console.log("📝 Guardando consentimiento para cita:", citaId);

        const citaRef = doc(db, "citasGlobales", citaId);
        const now = new Date();

        await updateDoc(citaRef, {
          tratamiento: {
            consentimientoLaser: {
              aceptado: true,
              aceptadoPor: paciente.nombre || "Desconocido",
              fecha: now.toLocaleDateString("es-PR"),
              hora: now.toLocaleTimeString("es-PR"),
            },
          },
        });

        console.log("✅ Consentimiento guardado");

        // Refrescar citas y forzar reevaluación de pacientes
        await this.cargarCitasGlobales();

        this.$nextTick(() => {
          console.log("🔄 pacientesPaginados:", this.pacientesPaginados);
        });

        // Limpiar modal
        this.mostrarModalConsentimiento = false;
        this.pacienteConsentimiento = null;
        this.citaConsentimiento = null;
        this.consentimientoTexto = "";

        alert("Consentimiento guardado correctamente");
      } catch (err) {
        console.error("Error al guardar consentimiento:", err.message, err);
        alert("Error al guardar el consentimiento. Intenta de nuevo.");
      }
    },

    abrirConsentimiento(cita) {
      if (!cita) {
        console.warn(" Cita no válida para consentimiento");
        return;
      }

      const paciente = this.pacientes.find((p) => p.uid === cita.pacienteId);
      if (!paciente) {
        console.warn(" No se encontró el paciente para esta cita");
        return;
      }

      this.pacienteConsentimiento = paciente;
      this.citaConsentimiento = cita;
      // Construir el mapa de datos para el consentimiento
      const map = {
        CLIENTE_NOMBRE_COMPLETO: `${paciente.nombre} ${
          paciente.apellido || ""
        }`,
        CLIENTE_LICENCIA: paciente.licenciaCliente || "____________",
        FECHA_NACIMIENTO: paciente.fechaNacimiento || "____/__/__",
        FIRMA_NOMBRE: `${paciente.nombre} ${paciente.apellido || ""}`,
        FECHA_FIRMA: new Date().toLocaleDateString("es-PR"),
        TUTOR_PARENTEZCO: paciente.tutorParentesco || "",
        TUTOR_LICENCIA: paciente.tutorLicencia || "",
      };

      // Reemplazar variables en la plantilla
      const texto = replacePlaceholders(CONSENTIMIENTO_DEPILACION_LASER, map);

      // Mostrar en el modal
      this.consentimientoTexto = texto;
      this.mostrarModalConsentimiento = true;
    },

    onFileChange(e) {
      this.selectedImage = e.target.files[0];
      console.log("Imagen seleccionada para la nota:", this.selectedImage);
    },

    async cargarAnalisisPiel() {
      try {
        const uid = this.pacienteSeleccionado?.uid;
        if (!uid) return;

        const ref = doc(db, "pacientes", uid);
        const snap = await getDoc(ref);

        if (snap.exists()) {
          this.analisis = snap.data().analisisPiel || [];
          this.analisisGuardado = this.analisis.length > 0;
        } else {
          this.analisis = [];
          this.analisisGuardado = false;
        }
      } catch (error) {
        console.error(" Error al cargar análisis de piel:", error);
      }
    },

    async guardarAnalisisPiel() {
      const uid = this.pacienteSeleccionado?.uid;
      if (!uid) return;

      const ref = doc(db, "pacientes", uid);

      const nuevo = {
        fecha: new Date().toISOString().split("T")[0],
        tipoPiel: this.nuevoAnalisis.tipoPiel,
        observaciones: this.nuevoAnalisis.observaciones,
        alteraciones: this.nuevoAnalisis.alteraciones,
      };

      await updateDoc(ref, {
        analisisPiel: arrayUnion(nuevo),
      });

      this.nuevoAnalisis = {
        tipoPiel: "",
        observaciones: "",
        alteraciones: [],
      };
      this.cargarAnalisisPiel();
    },

    async guardarRecomendaciones() {
      const uid = this.pacienteSeleccionado?.id;
      if (!uid) return alert("Paciente no válido");

      try {
        const ref = collection(db, "pacientes", uid, "recomendaciones");

        // Opcional: Limpiar recomendaciones anteriores
        const snapshot = await getDocs(ref);
        const batch = writeBatch(db);
        snapshot.forEach((doc) => batch.delete(doc.ref));
        await batch.commit();

        // Agregar nuevas
        for (const producto of this.recomendacionesSeleccionadas) {
          await addDoc(ref, {
            productoId: producto.id,
            nombre: producto.nombre,
            precio: producto.precio,
            creado: new Date(),
          });
        }

        alert(" Recomendaciones guardadas");
      } catch (e) {
        console.error(" Error:", e);
        alert("Hubo un problema al guardar.");
      }
    },

    async guardarNota(citaId) {
      const notaTexto = this.nuevaNota[citaId]?.trim();
      if (!notaTexto) return alert(" La nota está vacía.");

      const citaRef = doc(db, "citasGlobales", citaId);
      const citaSnap = await getDoc(citaRef);
      if (!citaSnap.exists()) return alert(" Cita no encontrada.");

      const citaData = citaSnap.data();
      const notasActuales = citaData.notas || [];

      // Subir la imagen si está seleccionada
      let imagenUrl = "";
      if (this.selectedImage) {
        const imgRef = sRef(
          storage,
          `tratamientos/${citaId}/${this.selectedImage.name}`
        );
        await uploadBytes(imgRef, this.selectedImage);
        imagenUrl = await getDownloadURL(imgRef);
      }

      const now = new Date();
      const nueva = {
        texto: notaTexto,
        fecha: now.toLocaleDateString(),
        hora: now.toLocaleTimeString(),
        imagenUrl,
      };

      await updateDoc(citaRef, {
        notas: [...notasActuales, nueva],
      });

      alert(" Nota guardada");
      this.nuevaNota[citaId] = "";
      this.selectedImage = null;

      await this.cargarTratamientos();
    },

    async cargarTratamientos() {
      const pacienteId =
        this.pacienteSeleccionado.pacienteId || this.pacienteSeleccionado.id;
      console.log(" paciente ID usado:", pacienteId);

      if (!pacienteId) {
        console.warn(" pacienteId no está definido");
        return;
      }

      try {
        const q = query(
          collection(db, "citasGlobales"),
          where("pacienteId", "==", pacienteId)
        );
        const snapshot = await getDocs(q);
        this.tratamientos = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log(" tratamientos cargados:", this.tratamientos);
      } catch (error) {
        console.error(" error al cargar tratamientos:", error);
        this.tratamientos = [];
      }
    },

    activarPestanaTratamiento() {
      console.log(" activando pestaña tratamiento");
      this.pestanaActiva = "tratamiento";
      this.cargarTratamientos();
    },

    cambiarPagina(nuevaPagina) {
      if (nuevaPagina > 0 && nuevaPagina <= this.totalPaginas) {
        this.paginaActual = nuevaPagina;
      }
    },
    actualizarPacientesPorPagina() {
      this.paginaActual = 1;
      // Recalcular la lista visible manteniendo el filtro actual
      this.filtrarPacientes();
    },

    async abrirModal() {
      this.mostrarModal = true;
      this.direccionValida = null;
      this.direccionInvalida = null;
      this.autocomplete = false;
      this.resetForm();
    },
    cerrarModal() {
      this.mostrarModal = false;
      this.direccionInvalida = null;
      this.direccionValida = null;

      this.resetForm();
    },

    async abrirModalFicha(paciente) {
      this.pacienteSeleccionado = paciente;
      this.mostrarModalFicha = true;
      await this.cargarTratamientos();
      // Cargar recomendaciones existentes cuando se abre la ficha
      await this.cargarRecomendacionesExistentes();
    },

    async cargarRecomendacionesExistentes() {
      const uid = this.pacienteSeleccionado?.id;
      if (!uid) return;

      try {
        // Limpiar selecciones previas
        this.recomendacionesSeleccionadas = [];

        // Cargar recomendaciones guardadas
        const ref = collection(db, "pacientes", uid, "recomendaciones");
        const snapshot = await getDocs(ref);
        const recomendacionesGuardadas = snapshot.docs.map((doc) => doc.data());

        // Marcar productos que ya están recomendados
        this.recomendacionesSeleccionadas = this.productosDisponibles.filter(
          (producto) =>
            recomendacionesGuardadas.some(
              (rec) => rec.productoId === producto.id
            )
        );

        console.log(
          "Recomendaciones cargadas:",
          this.recomendacionesSeleccionadas
        );
      } catch (e) {
        console.error("Error cargando recomendaciones:", e);
      }
    },

    async activarPestanaRecomendaciones() {
      this.pestanaActiva = "recomendaciones";
      await this.cargarRecomendacionesExistentes();
    },
    cerrarModalFicha() {
      this.pacienteSeleccionado = {};
      this.mostrarModalFicha = false;
    },
    // Método para generar una contraseña aleatoria de 8 caracteres
    generarContraseñaAleatoria() {
      const caracteres =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@$*";
      let contraseña = "";
      for (let i = 0; i < 8; i++) {
        const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
        contraseña += caracteres[indiceAleatorio];
      }
      return contraseña;
    },
    async registerNewUser(email, password) {
      const secondaryApp = initializeApp(firebaseConfig, "Secondary");
      try {
        const secondaryAuth = getAuth(secondaryApp);

        // Crea el usuario en la app secundaria
        const userCredential = await createUserWithEmailAndPassword(
          secondaryAuth,
          email,
          password
        );

        // Obtén el UID del usuario creado

        // Elimina la app secundaria
        await deleteApp(secondaryApp);

        return userCredential.user; // Devuelve el UID del usuario creado
      } catch (error) {
        console.error("Error creando usuario:", error);

        // Asegúrate de eliminar la app secundaria incluso si hay un error
        await deleteApp(secondaryApp);

        throw error; // Relanza el error para manejarlo en el componente
      }
    },

    async acortarUrl(url) {
      try {
        const response = await fetch(
          `https://tinyurl.com/api-create.php?url=${encodeURIComponent(url)}`
        );
        if (!response.ok) {
          throw new Error("Error al acortar la URL");
        }
        const urlAcortada = await response.text();
        return urlAcortada;
      } catch (error) {
        console.error("Error al acortar la URL:", error);
        throw error;
      }
    },
    async crearPaciente() {
      const auth = getAuth(); // Inicializa Firebase Auth

      const answersPayload = { ...this.answers };
      const { raw: emailRaw, lower: emailLower } = this.obtenerEmailNormalizado();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      if (!emailRaw || !emailRegex.test(emailRaw)) {
        alert("Proporcione un correo electrónico válido para el paciente.");
        return;
      }
      this.email = emailRaw;
      answersPayload.email = emailRaw;
      answersPayload.emailLower = emailLower;

      const { nombre: nombrePaciente, apellido: apellidoPaciente } =
        this.extraerNombreApellido(answersPayload);
      if (!nombrePaciente) {
        alert("Proporcione al menos el nombre del paciente.");
        return;
      }
      const telefonoPaciente = (
        answersPayload.telefono ??
        this.telefono ??
        ""
      )
        .toString()
        .trim();
      const direccionPaciente =
        (answersPayload.direccion || this.direccion || "").toString().trim();

      this.nombre = nombrePaciente;
      this.apellido = apellidoPaciente;
      this.telefono = telefonoPaciente;
      this.direccion = direccionPaciente;

      const nuevoPaciente = {
        ...answersPayload,
        nombre: nombrePaciente,
        apellido: apellidoPaciente,
        direccion: direccionPaciente,
        telefono: telefonoPaciente,
        condiciones: this.condiciones,
        medicamentos: this.medicamentos,
        email: emailRaw,
        answers: answersPayload,
      };

      try {
        // Verificar si el correo ya está registrado
        const signInMethods = await fetchSignInMethodsForEmail(
          auth,
          emailRaw
        );

        if (signInMethods.length > 0) {
          alert("Este correo ya está registrado.");
          return;
        }

        // Generar la contraseña temporal aleatoria
        const temporalPassword = this.generarContraseñaAleatoria();
        const user = await this.registerNewUser(emailRaw, temporalPassword);

        // Crear el paciente en Firestore utilizando el UID del paciente
await setDoc(doc(db, "pacientes", user.uid), {
  ...nuevoPaciente,                  // Datos del formulario admin
  uid: user.uid,                    // UID real del Auth
  role: "paciente",                 // Rol del usuario
  status: "activo",                 // Estado consistente con la app
  activo: true,                     // Para compatibilidad con filtros
  passwordTemporal: true,           // IMPORTANTE: requerido para activar desde el link
  emailLower, // Normalización consistente
  fechaRegistro: serverTimestamp(), // Igual que los registrados desde la web
});


        // Llamar a la Cloud Function para enviar el correo al paciente con la contraseña temporal
        const functions = getFunctions(); // Inicializar las funciones de Firebase
        const enviarCorreo = httpsCallable(functions, "enviarCorreoPaciente"); // Llamar a la función Cloud

        // Enviar el correo con el enlace de registro, pasando el UID del paciente y la contraseña temporal
        await enviarCorreo({
          email: emailRaw,
          nombre: nombrePaciente,
          apellido: apellidoPaciente,
          pacienteId: user.uid, // Aquí pasamos el UID
          temporalPassword, // Pasar la contraseña temporal para que el paciente pueda iniciar sesión
        });
        if (telefonoPaciente) {
          const sendSms = httpsCallable(functions, "sendSms");
          const enlaceRegistro = `https://nat-spa.web.app/crear-cuenta/${
            user.uid
          }?email=${encodeURIComponent(emailRaw)}&pas=${encodeURIComponent(
            temporalPassword
          )}`;
          const tinyUrl = await this.acortarUrl(enlaceRegistro);

          await sendSms({
            message: `Bienvenido a Nat Spa
          Hola ${nombrePaciente}
          Su cuenta ha sido creada exitosamente. Su contraseña temporal es:${temporalPassword}
          Haga click en el siguiente enlace para completar su registro y cambiar su contraseña: \n
          ${tinyUrl}`,
            to: telefonoPaciente,
          });
        }
        alert("Paciente creado con éxito");

        // Cargar la lista de pacientes nuevamente y resetear el formulario
        this.cargarPacientes();
        this.cerrarModal();
      } catch (e) {
        console.error("Error al crear paciente desde admin:", e);
        if (String(e).includes("auth/email-already-in-use")) {
          alert("No se puede registrar, ya se registró ese email.");
        } else {
          alert(
            `No se pudo crear el paciente. Detalle: ${
              e?.message || "Error desconocido"
            }`
          );
        }
      }
    },

    async actualizarPaciente() {
      const pacienteRef = doc(db, "pacientes", this.pacienteEditandoId);
      try {
        const answersPayload = { ...this.answers };
        await updateDoc(pacienteRef, {
          ...answersPayload,
          nombre: this.nombre,
          apellido: this.apellido,
          email: this.email,
          direccion: this.direccion,
          telefono: this.telefono,
          condiciones: this.condiciones,
          medicamentos: this.medicamentos,
          answers: answersPayload,
        });

        alert("Paciente actualizado con éxito!");
        this.cargarPacientes();
        this.cerrarModal();
      } catch (e) {
        console.error("Error al actualizar el paciente:", e);
      }
    },

    async eliminarPaciente(paciente) {
      if (!paciente) {
        console.error("El ID del paciente no es válido:", paciente.id);
        alert(
          "Hubo un problema al intentar eliminar el paciente. Por favor, inténtalo de nuevo."
        );
        return;
      }

      if (confirm("¿Estás seguro de eliminar este paciente?")) {
        try {
          const functions = getFunctions();
          const deleteUser = httpsCallable(functions, "eliminarUsuario");

          if (paciente.id && paciente.uid && paciente.id != paciente.uid) {
            //xd
            await deleteUser({ uid: paciente.uid });
            await deleteDoc(doc(db, "pacientes", paciente.uid));
          } else {
            await deleteUser({ uid: paciente.id });

            // Ahora eliminamos el documento del paciente en Firestore
            await deleteDoc(doc(db, "pacientes", paciente.id));
          }

          alert("Paciente eliminado.");
          this.cargarPacientes();
        } catch (e) {
          console.error("Error al eliminar el paciente:", e);
          const mensajeError = e.message || JSON.stringify(e);
          alert(`Hubo un error al eliminar el paciente: ${mensajeError}`);
        }
      }
    },

    async cargarPacientes() {
      try {
        const querySnapshot = await getDocs(collection(db, "pacientes"));
        this.pacientes = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        this.filtrarPacientes();
      } catch (e) {
        console.error("Error al cargar los pacientes:", e);
        alert("Hubo un error al cargar los pacientes.");
      }
    },

    editarPaciente(paciente) {
      this.nombre = paciente.nombre;
      this.apellido = paciente.apellido;
      this.direccion = paciente.direccion;
      this.telefono = paciente.telefono;
      this.email = paciente.email;
      this.telefonoAlterno = paciente.telefonoAlterno || "";
      this.peso = paciente.peso || "";
      this.pies = paciente.pies || "";
      this.pulgadas = paciente.pulgadas || "";

      // Respuestas del formulario
      const respuestas = paciente.answers || {};
      const normalizedAnswers = buildEmptyAnswers();
      this.questions.forEach((q) => {
        if (q.type === "checkbox-group") {
          if (Array.isArray(respuestas[q.id])) {
            normalizedAnswers[q.id] = respuestas[q.id];
          } else if (Array.isArray(paciente[q.id])) {
            normalizedAnswers[q.id] = paciente[q.id];
          } else {
            normalizedAnswers[q.id] = [];
          }
        } else if (q.type === "multi-input" && q.inputs) {
          q.inputs.forEach((input) => {
            normalizedAnswers[input.id] =
              respuestas[input.id] ??
              paciente[input.id] ??
              "";
          });
        } else {
          normalizedAnswers[q.id] =
            respuestas[q.id] ??
            paciente[q.id] ??
            "";
        }
      });
      this.answers = normalizedAnswers;
      this.sincronizarEdadDesdeFecha();

      this.esEdicion = true;
      this.pacienteEditandoId = paciente.id;
      this.mostrarModal = true;
    },

    filtrarPacientes() {
      const termino = (this.filtro || "").toString().trim().toLowerCase();
      const base =
        this.pacientesActualizados?.length > 0
          ? this.pacientesActualizados
          : this.pacientes;

      if (!termino) {
        this.pacientesFiltrados = [...base];
        this.paginaActual = 1;
        return;
      }

      this.pacientesFiltrados = base.filter((paciente = {}) => {
        const campos = [
          paciente.nombre,
          paciente.apellido,
          paciente.email,
          paciente.telefono,
          paciente.direccion,
          paciente.licenciaCliente,
          `${paciente.nombre || ""} ${paciente.apellido || ""}`,
        ]
          .filter(Boolean)
          .map((valor) => valor.toString().toLowerCase());

        return campos.some((valor) => valor.includes(termino));
      });

      this.paginaActual = 1;
    },

    async resetForm() {
      this.nombre = "";
      this.apellido = "";
      this.direccion = "";
      this.telefono = "";
      this.condiciones = "";
      this.medicamentos = "";
      this.email = "";
      this.esEdicion = false;
      this.pacienteEditandoId = null;
      this.coordenadas = null;

      // ✅ Limpieza completa de las respuestas dinámicas
      this.answers = buildEmptyAnswers();
      this.sincronizarEdadDesdeFecha();
    },
    

    // Función para calcular impuesto de producto
    calcularImpuestoProducto(producto) {
      if (!producto.tipo || producto.tipo === "servicio") return 0;
      return producto.precio * 0.16; // 16% de impuesto para productos
    },
  },

  // ... otros campos como data, components, methods...

  async mounted() {
    console.log(" Citas cargadas:", this.citasGlobales);
    this.sincronizarEdadDesdeFecha();

    await this.cargarAnalisisPiel();
    await this.cargarPacientes();

    

    //  Cargar productos y categorías
    const [productosSnap, categoriasSnap] = await Promise.all([
      getDocs(collection(db, "productos")),
      getDocs(collection(db, "categorias")),
    ]);
    const citasSnap = await getDocs(collection(db, "citasGlobales"));
    this.citasGlobales = citasSnap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    const categorias = categoriasSnap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    //  Buscar ID de categoría "laser"
    const categoriaLaser = categorias.find((c) =>
      c.nombre.toLowerCase().includes("laser")
    );

    const productos = productosSnap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    this.productosDisponibles = productos.filter((p) => p.visible !== false);

    // ✅ Filtrar servicios que pertenecen a "laser"
    this.serviciosLaser = categoriaLaser
      ? productos.filter(
          (p) => p.tipo === "servicio" && p.categoria === categoriaLaser.id
        )
      : [];

    this.categoriasMap = Object.fromEntries(
      categorias.map((c) => [c.id, c.nombre.toLowerCase()])
    );

    //  Modal de paciente
    eventBus.on("abrirModalDesdeSolicitud", ({ paciente, pestana }) => {
      this.mostrarModalFicha = true;
      this.pacienteSeleccionado = paciente;
      this.pestanaActiva = pestana;
    });
  },

  watch: {
    pestanaActiva(nueva) {
      if (nueva === "analisisPiel") {
        this.cargarAnalisisPiel();
      }
    },
    pacientesActualizados: {
      handler() {
        this.filtrarPacientes();
      },
      deep: true,
    },
    "answers.fechaNacimiento"(nuevaFecha) {
      this.answers.edad = this.calcEdad(nuevaFecha);
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .modal-content {
    max-height: 80vh;
    /* Limita el alto del modal */
    overflow-y: auto;
    /* Habilita desplazamiento vertical */
  }
}
</style>
